import { render, staticRenderFns } from "./CostTypeTable.vue?vue&type=template&id=1b9a4164&scoped=true&"
import script from "./CostTypeTable.vue?vue&type=script&lang=js&"
export * from "./CostTypeTable.vue?vue&type=script&lang=js&"
import style0 from "./CostTypeTable.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./CostTypeTable.vue?vue&type=style&index=1&id=1b9a4164&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b9a4164",
  null
  
)

export default component.exports